(function () {
  if (window.__voProductOriginReady) return;
  window.__voProductOriginReady = true;

  var STORAGE_KEY = 'voProductOrigin';
  var MAX_ORIGIN_AGE_MS = 30 * 60 * 1000;

  function parseUrl(value, base) {
    try {
      return new URL(value, base || window.location.href);
    } catch (error) {
      return null;
    }
  }

  function isSameOrigin(url) {
    return Boolean(url && url.origin === window.location.origin);
  }

  function getPathSegments(url) {
    return url.pathname.split('/').filter(Boolean);
  }

  function getSegmentAfter(url, segmentName) {
    var segments = getPathSegments(url);
    var segmentIndex = segments.indexOf(segmentName);

    if (segmentIndex === -1 || !segments[segmentIndex + 1]) return '';

    return decodeURIComponent(segments[segmentIndex + 1]);
  }

  function getProductHandle(url) {
    return getSegmentAfter(url, 'products');
  }

  function getCollectionHandle(url) {
    return getSegmentAfter(url, 'collections');
  }

  function isSearchUrl(url) {
    return getPathSegments(url).indexOf('search') !== -1;
  }

  function isProductUrl(url) {
    return getProductHandle(url) !== '';
  }

  function toRelativeUrl(url) {
    return url.pathname + url.search + url.hash;
  }

  function normalizeRelativeUrl(value) {
    var url = parseUrl(value);
    if (!url) return '';

    return toRelativeUrl(url).replace(/\/$/, '');
  }

  function titleFromHandle(handle) {
    return String(handle || '')
      .split('-')
      .filter(Boolean)
      .map(function (part) {
        return part.charAt(0).toUpperCase() + part.slice(1);
      })
      .join(' ');
  }

  function getText(selector) {
    var element = document.querySelector(selector);
    return element ? element.textContent.trim() : '';
  }

  function getFieldValue(selector) {
    var field = document.querySelector(selector);
    return field && 'value' in field ? String(field.value || '').trim() : '';
  }

  function getSearchLabel(url) {
    var params = new URLSearchParams(url.search);
    var query = params.get('q') || getFieldValue('.vo-main-search__input') || '';

    return query ? 'Search: ' + query : 'Search';
  }

  function resolveCurrentOrigin() {
    var currentUrl = parseUrl(window.location.href);
    if (!currentUrl || isProductUrl(currentUrl)) return null;

    var collectionHandle = getCollectionHandle(currentUrl);
    if (collectionHandle) {
      return {
        type: 'collection',
        handle: collectionHandle,
        label: getText('.vo-collection-plp__breadcrumb-current') || getText('h1') || titleFromHandle(collectionHandle),
        url: toRelativeUrl(currentUrl),
      };
    }

    if (isSearchUrl(currentUrl)) {
      return {
        type: 'search',
        label: getSearchLabel(currentUrl),
        url: toRelativeUrl(currentUrl),
      };
    }

    return null;
  }

  function writeOriginForProductLink(link) {
    if (!link || link.target === '_blank') return;

    var targetUrl = parseUrl(link.getAttribute('href'));
    if (!isSameOrigin(targetUrl) || !isProductUrl(targetUrl)) return;

    var origin = resolveCurrentOrigin();
    if (!origin || !origin.label || !origin.url) return;

    try {
      window.sessionStorage.setItem(
        STORAGE_KEY,
        JSON.stringify({
          productHandle: getProductHandle(targetUrl),
          type: origin.type,
          handle: origin.handle || '',
          label: origin.label,
          url: origin.url,
          storedAt: Date.now(),
        })
      );
    } catch (error) {
      // Storage can be blocked in privacy modes. Referrer-based fallback still applies.
    }
  }

  function getProductContext() {
    var contextScript = document.querySelector('[data-vo-product-origin-context]');
    if (!contextScript) return null;

    try {
      var context = JSON.parse(contextScript.textContent || '{}');
      context.collections = Array.isArray(context.collections) ? context.collections : [];
      return context;
    } catch (error) {
      return null;
    }
  }

  function readStoredOrigin(context) {
    if (!context || !context.productHandle) return null;

    try {
      var rawValue = window.sessionStorage.getItem(STORAGE_KEY);
      if (!rawValue) return null;

      var origin = JSON.parse(rawValue);
      var storedUrl = parseUrl(origin.url);
      if (!isSameOrigin(storedUrl) || isProductUrl(storedUrl)) return null;
      if (origin.productHandle !== context.productHandle) return null;
      if (Date.now() - Number(origin.storedAt || 0) > MAX_ORIGIN_AGE_MS) return null;

      return {
        type: origin.type || '',
        handle: origin.handle || '',
        label: origin.label || '',
        url: toRelativeUrl(storedUrl),
      };
    } catch (error) {
      return null;
    }
  }

  function findCollectionByReferrer(context, referrerUrl) {
    var referrerHandle = getCollectionHandle(referrerUrl);
    if (!referrerHandle || !context) return null;

    return context.collections.find(function (collection) {
      var collectionUrl = parseUrl(collection.url);
      return (
        collection.handle === referrerHandle ||
        (collectionUrl && getCollectionHandle(collectionUrl) === referrerHandle)
      );
    });
  }

  function readReferrerOrigin(context) {
    if (!document.referrer) return null;

    var referrerUrl = parseUrl(document.referrer);
    if (!isSameOrigin(referrerUrl) || isProductUrl(referrerUrl)) return null;

    var referrerCollection = findCollectionByReferrer(context, referrerUrl);
    if (referrerCollection) {
      return {
        type: 'collection',
        handle: referrerCollection.handle,
        label: referrerCollection.title,
        url: toRelativeUrl(referrerUrl),
      };
    }

    var referrerCollectionHandle = getCollectionHandle(referrerUrl);
    if (referrerCollectionHandle) {
      return {
        type: 'collection',
        handle: referrerCollectionHandle,
        label: titleFromHandle(referrerCollectionHandle),
        url: toRelativeUrl(referrerUrl),
      };
    }

    if (isSearchUrl(referrerUrl)) {
      return {
        type: 'search',
        label: getSearchLabel(referrerUrl),
        url: toRelativeUrl(referrerUrl),
      };
    }

    return null;
  }

  function resolveProductOrigin(context) {
    var storedOrigin = readStoredOrigin(context);
    var referrerOrigin = readReferrerOrigin(context);

    if (storedOrigin && referrerOrigin) {
      var sameUrl = normalizeRelativeUrl(storedOrigin.url) === normalizeRelativeUrl(referrerOrigin.url);
      var sameCollection = storedOrigin.type === 'collection' && storedOrigin.handle === referrerOrigin.handle;
      var sameSearch = storedOrigin.type === 'search' && referrerOrigin.type === 'search';

      if (sameUrl || sameCollection || sameSearch) {
        return {
          type: referrerOrigin.type,
          handle: referrerOrigin.handle || storedOrigin.handle,
          label: storedOrigin.label || referrerOrigin.label,
          url: referrerOrigin.url || storedOrigin.url,
        };
      }
    }

    return referrerOrigin || storedOrigin;
  }

  function updateBackLinks(origin) {
    if (!origin || !origin.url) return;

    document.querySelectorAll('[data-vo-product-back-link]').forEach(function (link) {
      link.setAttribute('href', origin.url);
    });
  }

  function updateBreadcrumbs(origin) {
    if (!origin || !origin.label || !origin.url) return;

    document.querySelectorAll('[data-vo-product-breadcrumbs]').forEach(function (breadcrumbs) {
      var separator = breadcrumbs.querySelector('[data-vo-product-origin-separator]');
      var link = breadcrumbs.querySelector('[data-vo-product-origin-link]');
      if (!link) return;

      link.textContent = origin.label;
      link.setAttribute('href', origin.url);
      link.hidden = false;

      if (separator) separator.hidden = false;
    });
  }

  function canUseHistoryBack() {
    var referrerUrl = parseUrl(document.referrer);
    var currentUrl = parseUrl(window.location.href);

    return (
      window.history.length > 1 &&
      isSameOrigin(referrerUrl) &&
      normalizeRelativeUrl(toRelativeUrl(referrerUrl)) !== normalizeRelativeUrl(toRelativeUrl(currentUrl))
    );
  }

  function initProductOrigin() {
    var context = getProductContext();
    if (!context) return;

    var origin = resolveProductOrigin(context);
    updateBackLinks(origin);
    updateBreadcrumbs(origin);
  }

  document.addEventListener(
    'click',
    function (event) {
      var link = event.target.closest && event.target.closest('a[href]');
      if (!link || event.defaultPrevented) return;

      writeOriginForProductLink(link);

      if (!link.matches('[data-vo-product-back-link]') || !canUseHistoryBack()) return;

      event.preventDefault();
      window.history.back();
    },
    true
  );

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initProductOrigin);
  } else {
    initProductOrigin();
  }

  document.addEventListener('shopify:section:load', initProductOrigin);

  window.__voProductOrigin = {
    getCollectionHandle: function (value) {
      var url = parseUrl(value);
      return url ? getCollectionHandle(url) : '';
    },
    getProductHandle: function (value) {
      var url = parseUrl(value);
      return url ? getProductHandle(url) : '';
    },
    titleFromHandle: titleFromHandle,
  };
})();
